<template>
  <v-container>
    <v-row>
      <permission-guard situation="tag_management">
        <v-form ref="form">
          <v-col cols="10" lg="10" offset-lg="1">
            <v-textarea
              v-model='postIds'
              :rules="[validatePostIds]"
              label='対象の記事ID（カンマ区切り）'
              style='width: 400px'
              outlined
              rows='3'
              required
            />
            <v-select
              v-model='isCategory'
              label='タイプを選択してください'
              :items='items'
              item-value='value'
              item-text='name'
              persistent-hint
              style='width: 300px'
            />
            <TagSelector
              style='width: 300px'
              :tag="tag.id"
              label="カテゴリー、タグ"
              :filter="selectableParentTagsFilter"
              @change-tag="setParentId"
            ></TagSelector>
            <v-col>
              <div v-if="updatedPostIds.length">
                更新された記事ID: {{ updatedPostIds.join(', ') }}
              </div>
              <div v-if="skippedPostIds.length">
                スキップされた記事ID: {{ skippedPostIds.join(', ') }}
              </div>
              <div v-if="failedPostIds.length">
                失敗した記事ID: {{ failedPostIds.join(', ') }}
              </div>
            </v-col>
            <v-btn
              color="primary"
              dark
              tile
              outlined
              small
              class="ma-3"
              type="button"
              @click="setTagsAssignment"
            >
              設定
            </v-btn>
          </v-col>
        </v-form>
      </permission-guard>
    </v-row>
  </v-container>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import axios from 'axios'
import { mapState } from 'vuex'
import TagSelector from '@/components/commons/tags/TagSelector'
import formValidationUtils from '@/mixins/form_validation_utils'
import PermissionGuard from '@/components/commons/PermissionGuard'

export default {
  name: 'TagsAssignment',
  components: {
    TagSelector,
    PermissionGuard
  },
  mixins: [headUtilsMixin, formValidationUtils],
  data: function () {
    return {
      postIds: [],
      tag: {
        priority: 0
      },
      items: [
        {
          name: 'カテゴリー',
          value: true
        },
        {
          name: 'タグ',
          value: false
        }
      ],
      isCategory: true,
      updatedPostIds: [],
      skippedPostIds: [],
      failedPostIds: []
    }
  },
  watch: {
    value (newValue) {
      this.tag = { ...newValue }
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  methods: {
    validatePostIds (value) {
      if (typeof value !== 'string') {
        value = String(value)
      }
      const ids = value.split(',').filter(Boolean)
      if (ids.length > 300) {
        return 'IDの数が300個を超えています。'
      }
      if (!/^\d+(,\d+)*$/.test(value)) {
        return '入力値が無効です。半角数字とカンマのみ使用してください。'
      }
      return true
    },
    setParentId (value) {
      if (value && value.id !== this.tag.id) {
        this.tag.parentId = value.id
      } else {
        this.tag.parentId = null
      }
    },
    setTagsAssignment () {
      this.updatedPostIds = []
      this.skippedPostIds = []
      this.failedPostIds = []

      const uniquePostIds = [...new Set(this.postIds.split(',').map(id => id.trim()))]
      this.postIds = uniquePostIds.join(',')

      const isValid = this.$refs.form.validate()
      if (!isValid) return
      const postIdsArray = this.postIds.split(',').map(id => id.trim())
      axios.post('/api/tags_assignment', {
        postIds: postIdsArray,
        tagId: this.tag.parentId,
        isCategory: this.isCategory
      }).then(response => this.handleSuccess(response))
        .catch(error => this.handleError(error))
    },
    handleSuccess ({ data }) {
      this.$store.dispatch('LoaderStore/hideLoader')
      const { updatedPostIds, skippedPostIds } = data
      this.updatedPostIds = updatedPostIds
      this.skippedPostIds = skippedPostIds
      this.$store.dispatch('SystemMessageStore/createMessage', {
        status: 200,
        message: 'タグの連携されました。'
      })
    },
    handleError (error) {
      this.$store.dispatch('LoaderStore/hideLoader')
      this.$store.dispatch('SystemMessageStore/createMessage', {
        status: 442,
        message: '失敗した内容があります。'
      })
      if (error.response && error.response.data) {
        const { failed_post_ids, skipped_post_ids, updated_post_ids } = error.response.data
        this.failedPostIds = failed_post_ids
        this.skippedPostIds = skipped_post_ids
        this.updatedPostIds = updated_post_ids
      }
    },
    selectableParentTagsFilter (item, queryText, itemText) {
      return !!(
        (!this.tag || item.id !== this.tag.id) &&
        (item.id.toString() === queryText || itemText.includes(queryText))
      )
    }
  }
}
</script>

<style scoped></style>
